import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetCRM(id) {
  const URL = `${endpoints.crm.list}${id}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      leads: response?.leads || [],
      leadsLoading: isLoading,
      leadsError: error,
      leadsValidating: isValidating,
      leadsEmpty: !isLoading && !response?.leads?.length,
    }),
    [response?.leads, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// export async function CreateCRM(apiData, id) {
//   const URL = `${endpoints.leads.list}/${id}/assigned`;

//   try {
//     const { data } = await axios.post(endpoints.leads.create, apiData);
//     if (data.code === 200) {
//       await mutate(URL);
//     }
//     return data;
//   } catch (error) {
//     console.error('Error creating user:', error);
//     throw error;
//   }
// }

export async function updateCRM(apiData, id, managerId) {
  const URL = `${endpoints.crm.list}${managerId}`;
  try {
    const { data } = await axios.put(`${endpoints.crm.update}/${id}`, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function deleteCRM(userId, managerId) {
  const URL = `${endpoints.crm.list}${managerId}`;

  try {
    const { data } = await axios.delete(`${endpoints.crm.delete}/${userId}`);
    if (data.code === 200) {
      mutate(URL);
    }

    return data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}

export async function changeStatus(apiData, id, canId) {
  const URL = `${endpoints.crm.list}${canId}`;
  try {
    const { data } = await axios.put(`${endpoints.crm.change_status}/${id}`, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}
